import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

// TODO: add the group name to the title ("Client Group History: <name> | KellerConnect")
// once the group detail endpoint exists, like on the client pages.
export const Route = createFileRoute('/_app/clients/groups/$groupId/history')({
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle(
          'clients.group_history.page_title',
          'Client Group History',
        ),
      },
    ],
  }),
});
